import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import vSelect from 'vue-select';
import "vue-select/dist/vue-select.css";
import Toasted from 'vue-toasted';
import { initClient } from '../../../api';
import { AndonAPIClient, AndonSetting } from '../../backend/backendapi';

Vue.use(Toasted, { duration: 2000 });

@Component({
    name: 'AndonComponent',
    components: {
        vSelect
    }
})
export default class AndonComponent extends Vue {
    //data
    private settings: AndonSetting[] = [];

    //api
    private readonly API = initClient(AndonAPIClient);

    //runtime
    private selectedSetting: AndonSetting | null = null;

    mounted(): void {
        this.reload();
    }

    private async reload(): Promise<void> {
        const data = (await this.API.list()).result!;
        console.log(data);
        this.settings.splice(0);
        this.settings.push(...data);
    }

    private save(): void {
        if (!this.selectedSetting) {
            return;
        }
        this.API.update(this.selectedSetting)
            .then(e => this.$toasted.info(this.$t('txtSaved').toString()))
            .catch(e => this.$toasted.error(this.$t('txtError') + ': ' + JSON.stringify(e)));
    }
}